import { HttpClient, HttpHeaders, JsonpClientBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from '../dialogs/image-dialog/image.dialog';
import { ImageDownloadDialogComponent } from '../dialogs/image-download-dialog/image-download-dialog.component';
import { ConnectionService } from './connection.service';
import { ResponsiveService } from './responsive.service';
import { Media, MediaType } from '@contracts/interfaces/media.interfaces'

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService,
    private dialog: MatDialog,
    private responsiveService: ResponsiveService) {}
 
  

  open (media: Media) {
    this.check(media).subscribe((exists: any) => {
      if (exists) {
          // if it has a storage key...
          if (media.storageKey && media.storageKey.length > 0) {
              window.open(this.connectionService.address + "/" + media.path + "/" + media.storageKey, '_blank');
          }
          else {
            window.open(this.connectionService.address + "/" + media.path + "/" + media.filename, '_blank');
          }
      } else {
        alert("File does not exist on server.");
      }
    });
  }

  delete(image: Media) {
    return this.http.post(this.connectionService.address + '/image-service/delete', {
      image
    });
  }

  upload(file: File, media: Media, overwrite: boolean = false) {
    const formData: FormData = new FormData();

    formData.append('filename', media.filename);
    formData.append('path', media.path);
    formData.append('file', file);
    formData.append('overwrite', overwrite ? 'true': 'false');

    return this.http.post(this.connectionService.address + '/image-service/upload', formData, {
      headers: { authtoken: this.connectionService.activeConnection?.token || '' },
      reportProgress: true,
      observe: 'events'
    });
  }

  getType(media: Media | string) {
    return this.http.post(this.connectionService.address + '/image-service/get-type', {
      media
    })
  }

  check (media: Media) {
    return this.http.post(this.connectionService.address + '/image-service/check', {
      media
    });
  }

  download(media: Media, direct: boolean = true, callback: any) {

      let dialog = this.dialog.open(ImageDownloadDialogComponent, {
        autoFocus: false,
        width: '300px',
        data: {
          media,
          direct
        }
    });

    dialog.afterClosed().subscribe((r: any) => {
        if (callback != undefined) {
          callback(r);
        }
    });
  }

    /**
    * Opens the image editor dialog
    * @param image HTML Src for image
    * @param saveAs Server file path including filename where to save image too
    */
    public edit(media: Media, callback: any, options?: { list?: any[], index?: number, view?: boolean }) {

      let width = '95vw';
      if (this.responsiveService.isMobile) {
          width = '100%';
      }

      if (options == undefined) {
          options = {
            view: true,
            list: [],
            index: 0
          };
      }

      let dialog = this.dialog.open(ImageDialogComponent, {
          autoFocus: false,
          height: '100vh',
          width: width,
          maxHeight: '100vh',
          maxWidth: width,
          panelClass: ['full-screen-modal'],
          data: {
              media,
              view: options.view,
              list: options.list,
              index: options.index
          }
      });

      dialog.afterClosed().subscribe((r: any) => {
          callback(r);
      });
  }
}
